import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  Divider,
  FormGroup,
  FormField,
  TextArea,
  Dropdown,
  Button
} from 'semantic-ui-react'

const CardRehabExaminationUX = (props: any) => {
    return(
      <div
        id="CardRehabExaminationUX-div-0"
        style={{margin: "10px"}}>
        <div
          id="CardRehabExaminationUX-div-1"
          style={{fontWeight: "bolder",fontSize:"large"}}>
          {props.languageUX === "en" ? "Rehabilitation treatment plan" : "แผนการบำบัดฟื้นฟู"}
        </div>
        <Divider
          id="CardRehabExaminationUX-Divider-22">
        </Divider>
        <Form
          id="CardRehabExaminationUX-Form-5">
          <FormGroup
            id="CardRehabExaminationUX-FormGroup-37"
            widths={16}>
            <FormField
              id="CardRehabExaminationUX-FormField-39"
              width={8}>
              <label
                id="CardRehabExaminationUX-label-42">
                {props.languageUX === "en" ? "Problem" : "ปัญหา"}
              </label>
              <TextArea
                id="CardRehabExaminationUX-TextArea-44"
                onChange={props.onChangeProblem}
                value={props.problem}>
              </TextArea>
            </FormField>
            <FormField
              id="CardRehabExaminationUX-FormField-41"
              width={8}>
              <label
                id="CardRehabExaminationUX-label-43">
                {props.languageUX === "en" ? "Rehabilitation goal" : "เป้าหมายการฟื้นฟู"}
              </label>
              <TextArea
                id="CardRehabExaminationUX-TextArea-45"
                onChange={props.onChangeGoal}
                value={props.goal}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardRehabExaminationUX-FormGroup-38">
            <FormField
              id="CardRehabExaminationUX-FormField-40"
              width={16}>
              <label
                id="CardRehabExaminationUX-label-47">
                {props.languageUX === "en" ? "Precaution" : "ข้อควรระวัง"}
              </label>
              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardRehabExaminationUX-Dropdown-48"
                multiple={true}
                onAddItem={props.onAddItem}
                onChange={props.onChangePrecaution}
                options={props.precautionOptions}
                search={true}
                selection={true}
                value={props.precaution}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardRehabExaminationUX-div-23"
          style={{margin: "30px 0px 10px 0px",fontWeight: "bolder",fontSize:"larger"}}>
          {props.languageUX === "en" ? "Treatment Order" : "ลำดับการรักษา"}
        </div>
        <Form
          id="CardRehabExaminationUX-Form-49">
          <FormGroup
            id="CardRehabExaminationUX-FormGroup-56"
            inline={true}
            widths={16}>
            <FormField
              className="required"
              id="CardRehabExaminationUX-FormField-57"
              inline={true}
              style={{position: "relative"}}
              width={8}>
              <label
                id="CardRehabExaminationUX-label-66"
                style={{minWidth: "max-content"}}>
                Search Order 
              </label>
              <div
                id="CardRehabExaminationUX-div-63"
                style={{width: "100%"}}>
                {props.searchOrder}
              </div>
              <div
                id="CardRehabExaminationUX-div-68"
                style={{position: "absolute", bottom: "-1.35rem", right: "1rem", color: "#9f3a38", display: props.formErrors?.order? "":"none"}}>
                {props.languageUX === "en" ? "Please enter the information" : "กรุณากรอกข้อมูล"}
              </div>
            </FormField>
            <FormField
              className="required"
              id="CardRehabExaminationUX-FormField-58"
              inline={true}
              style={{position: "relative"}}
              width={8}>
              <label
                id="CardRehabExaminationUX-label-61"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "to Department" : "ไปที่แผนก"}
              </label>
              <Dropdown
                className={props.formErrors?.department? "error":""}
                fluid={true}
                id="CardRehabExaminationUX-Dropdown-64"
                onChange={props.onChangeDepartment}
                options={props.departmentOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.department}>
              </Dropdown>
              <div
                id="CardRehabExaminationUX-div-67"
                style={{position: "absolute", bottom: "-1.35rem", right: "1rem", color: "#9f3a38", display: props.formErrors?.department? "":"none"}}>
                {props.languageUX === "en" ? "Please enter the information" : "กรุณากรอกข้อมูล"}
              </div>
            </FormField>
            <FormField
              id="CardRehabExaminationUX-FormField-59">
              <Button
                color="blue"
                disabled={props.disabledAddBtn}
                id="CardRehabExaminationUX-Button-62"
                onClick={props.onClickAdd}>
                {props.languageUX === "en" ? "Add" : "เพิ่ม"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardRehabExaminationUX-div-24"
          style={{ margin: "20px 0px" }}>
          
          <div
            id="CardRehabExaminationUX-div-18">
            {props.table}
          </div>
        </div>
        <div
          id="CardRehabExaminationUX-div-28"
          style={{display:"flex",justifyContent:"flex-end", margin: "20px 10px" }}>
          
          <div
            style={{ width: "50%" }}>
            {props.doctorSearchBox}
          </div>
          <div
            id="CardRehabExaminationUX-div-69"
            style={{ width: "50%", textAlign: "right" }}>
            {props.buttonSave}
          </div>
        </div>
      </div>
    )
}


export default CardRehabExaminationUX

export const screenPropsDefault = {}

/* Date Time : Thu Sep 04 2025 09:47:55 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนการบำบัดฟื้นฟู",
          "valueEN": "Rehabilitation treatment plan"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bolder\",fontSize:\"large\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-Form-5"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-18"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Divider",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-Divider-22"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ลำดับการรักษา",
          "valueEN": "Treatment Order"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"30px 0px 10px 0px\",fontWeight: \"bolder\",fontSize:\"larger\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"20px 0px\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\", margin: \"20px 10px\" }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormGroup-37"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormGroup-38"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormField-39"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormField-40"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormField-41"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ปัญหา",
          "valueEN": "Problem"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-label-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "เป้าหมายการฟื้นฟู",
          "valueEN": "Rehabilitation goal"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-label-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "TextArea",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-TextArea-44"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeProblem"
        },
        "value": {
          "type": "code",
          "value": "props.problem"
        }
      },
      "seq": 44,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "TextArea",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-TextArea-45"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeGoal"
        },
        "value": {
          "type": "code",
          "value": "props.goal"
        }
      },
      "seq": 45,
      "void": true
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อควรระวัง",
          "valueEN": "Precaution"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-label-47"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Dropdown",
      "parent": 40,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-Dropdown-48"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddItem"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrecaution"
        },
        "options": {
          "type": "code",
          "value": "props.precautionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.precaution"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-Form-49"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormGroup",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormGroup-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormField-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-FormField-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "ไปที่แผนก",
          "valueEN": "to Department"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-label-61"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Button",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "Add"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAddBtn"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-Button-62"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAdd"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchOrder"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Dropdown",
      "parent": 58,
      "props": {
        "className": {
          "type": "code",
          "value": "props.formErrors?.department? \"error\":\"\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-Dropdown-64"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDepartment"
        },
        "options": {
          "type": "code",
          "value": "props.departmentOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.department"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "Search Order "
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณากรอกข้อมูล",
          "valueEN": "Please enter the information"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-1.35rem\", right: \"1rem\", color: \"#9f3a38\", display: props.formErrors?.department? \"\":\"none\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณากรอกข้อมูล",
          "valueEN": "Please enter the information"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-1.35rem\", right: \"1rem\", color: \"#9f3a38\", display: props.formErrors?.order? \"\":\"none\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardRehabExaminationUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", textAlign: \"right\" }"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearchBox"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 69,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 75,
  "name": "CardRehabExaminationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
